import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'

export interface ShopHintModalProps {
  text: string
  onClose: () => void
  place: number
  additionalActionsLeft?: React.ReactNode
}

/*
 * This is a Component that shows a note after one Power Meter is added to the Configurator
 */
const ShopHintModal: React.VFC<ShopHintModalProps> = ({ text, onClose, place, additionalActionsLeft }) => {
  const { t } = useCustomTranslation()

  const modalActions = {
    primary: {
      name: t('common.close'),
      onClick: onClose,
    },
  }

  return (
    <Dialog
      title={t('shop.common.hint')}
      onClose={onClose}
      actions={modalActions}
      additionalActionsLeft={additionalActionsLeft}
      maxWidth="xs"
      place={place}
    >
      <Typography variant="h3">{text}</Typography>
    </Dialog>
  )
}

export default ShopHintModal
